import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ArrowRight } from 'lucide-react';
import { categoriesAPI, uploadsAPI } from '../services/api';
import { categoryPath, subcategoryPath } from '../services/catalogPath';
import { useT } from '../services/i18n';
import { catName, subName } from '../services/catalogI18n';

const SLUGS = ['accessoires-voiture', 'produits-de-nettoyage-et-d-entretien-du-vehicule', 'outillage-equipement'];
const SHOWN = 5;

const AccessoriesSection = () => {
  const { t, lang } = useT();
  const [cats, setCats] = useState([]);
  useEffect(() => {
    categoriesAPI.getAll().then((list) => setCats(SLUGS.map((s) => list.find((c) => c.slug === s)).filter(Boolean))).catch(() => {});
  }, []);
  if (!cats.length) return null;

  return (
    <section className="py-6 sm:py-10 bg-gray-50" data-testid="accessories-section">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
          {t('home.accessoriesTitle')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cats.map((category) => {
            const subs = (category.subcategories || []).filter((s) => typeof s === 'string');
            return (
              <div key={category.slug} className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow group" data-testid={`accessories-card-${category.slug}`}>
                <div className="flex items-start gap-4">
                  <Link to={categoryPath(category)} className="w-24 h-24 flex-shrink-0 flex items-center justify-center" data-testid={`accessories-image-${category.slug}`}>
                    {category.image && <img src={uploadsAPI.resolveUrl(category.image)} alt={catName(category, lang)} loading="lazy" className="w-full h-full object-contain transition-transform duration-200 group-hover:scale-105" />}
                  </Link>
                  <div className="flex-1 min-w-0">
                    <Link to={categoryPath(category)} className="font-semibold text-gray-900 mb-3 block hover:text-orange-600 transition-colors" data-testid={`accessories-title-${category.slug}`}>
                      {catName(category, lang)}
                    </Link>
                    <ul className="space-y-1">
                      {subs.slice(0, SHOWN).map((item) => (
                        <li key={item}>
                          <Link to={subcategoryPath(category, item)} data-testid={`accessories-link-${category.slug}-${item}`} className="text-sm text-gray-600 hover:text-orange-600 flex items-center gap-1 transition-colors">
                            <ChevronRight size={12} className="text-gray-400 shrink-0" />
                            <span className="truncate">{subName(category, item, lang)}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                    {subs.length > SHOWN && (
                      <Link to={categoryPath(category)} className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-orange-600 hover:underline" data-testid={`accessories-all-${category.slug}`}>
                        {t('home.allSubcategories', { n: subs.length })} <ArrowRight size={14} />
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AccessoriesSection;
